
  import { defineComponent } from 'vue';

  import Loader from '@/components/Loader.vue';

  export const getAnalyticsNotesParagraphSlotName = (index: number): string => `paragraph-${index - 1}`;

  export default defineComponent({
    name: 'AnalyticsNotesForeignTradeTextWrapper',
    components: {
      Loader,
    },
    props: {
      paragraphCount: {
        type: Number,
        default: 2,
        validator: (value: number) => value >= 1,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isInitLoadedData: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      getParagraphSlotName(index: number): string {
        return getAnalyticsNotesParagraphSlotName(index);
      },
    },
  });
